export default __webpack_public_path__ + "static/media/1.7f59ec63.jpg";